//Will make this configurable later.
const visibleYears = [0, 1, 4, 9, 14, 29].reduce(
  (all, key) => (all[key] = true) && all,
  {},
);

export const useYears = () => {
  return visibleYears;
};
